import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config';

function ChangePassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (password.length < 6) {
        setError("Password must be at least 6 characters");
        return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/change-password`, { new_password: password }, {
         headers: { Authorization: `Bearer ${token}` }
      });
      localStorage.removeItem('must_change_password');
      setMessage("Password changed successfully. Redirecting...");
      setTimeout(() => {
          navigate('/');
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to change password');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">Change Password</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            You must change your password before continuing.
        </Typography>
        
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal" required fullWidth label="New Password" type="password"
            value={password} onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            margin="normal" required fullWidth label="Confirm Password" type="password"
            value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>Change Password</Button>
        </Box>
      </Box>
    </Container>
  );
}

export default ChangePassword;
